import { DATASOURCE_TYPE } from './location-select.constants';
import locationAdapter from './location-adapter';
import type { DataSource, Location } from './location-select.types';

type MockLocationSelectHelpers = {
	/**
	 * @deprecated
	 */
	getLocationDetails(query: string, location: Location): Promise<Location>;
	/**
	 * @deprecated
	 */
	generateGoogleMapsDatasource(): () => DataSource<Location[]>;
};

/**
 * Generate a mock to be used when writing unit tests that involve the
 * `LocationSelect` component.
 * @param suggestions - Mocked locations to be returned
 * from the Google Maps Datasource.
 *
 * @deprecated
 * Please use GoogleMapsMock or GoogleMapsMockFactory instead of this deprecated mock factory.
 * You can find more information in the README file.
 */
function LocationSelectHelpersMockFactory(
	suggestions: Location[],
): MockLocationSelectHelpers {
	const mock: MockLocationSelectHelpers = {
		async getLocationDetails(query: string, location: Location) {
			return Promise.resolve(location);
		},
		generateGoogleMapsDatasource() {
			return function generateMockedGoogleMapsDatasource(): DataSource<
				Location[]
			> {
				const datasource: DataSource<Location[]> = {
					type: DATASOURCE_TYPE,
					adapter: locationAdapter,
					async fetch({ query }) {
						if (String(query || '').length < 3) {
							return [];
						}

						return suggestions;
					},
				};

				return datasource;
			};
		},
	};

	return mock;
}

export default LocationSelectHelpersMockFactory;
